import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { ToastService } from '@shared/services/toast/toast.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private transloco: TranslocoService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse) => {
        if (response.status === 401) {
          return throwError(() => response);
        }
        if (response.error instanceof ErrorEvent) {
          this.toastService.open(
            this.transloco.translate('errors.' + response.error.error),
            'error'
          );
        } else {
          this.toastService.open(
            this.transloco.translate('errors.' + response.error.error),
            'error'
          );
        }
        return throwError(response);
      })
    );
  }
}
